/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/


import { object } from "prop-types";

/**
 * Enum para defaultTypes.
 * @readonly
 */

export const defaultTypes = Object.freeze({
    Guid: "00000000-0000-0000-0000-000000000000",
    String: "",
    Int: 0,
    double:0.00,
    byte:0,
    byteArray:[],
    Date: new Date(1900, 1, 1),
});

/**
 * Enum para Width Modal.
 * @readonly
 * @enum {{name: string, value: string | boolean}}
 */
export const enumSizeModal = Object.freeze({
    xs: "xs",
    sm: "sm",
    md: "md",
    lg: "lg",
    xl: "xl",
    disable: false,
});

export const meses = [
    { "label": "TODOS", "valor": "0" },
    { "label": "ENERO", "valor": "1" },
    { "label": "FEBRERO", "valor": "2" },
    { "label": "MARZO", "valor": "3" },
    { "label": "ABRIL", "valor": "4" },
    { "label": "MAYO", "valor": "5" },
    { "label": "JUNIO", "valor": "6" },
    { "label": "JULIO", "valor": "7" },
    { "label": "AGOSTO", "valor": "8" },
    { "label": "SEPTIEMBRE", "valor": "9" },
    { "label": "OCTUBRE", "valor": "10" },
    { "label": "NOVIEMBRE", "valor": "11" },
    { "label": "DICIEMBRE", "valor": "12" },
];
